import React, {useEffect} from "react"
import {Switch, Route} from "react-router-dom"
import classnames from "classnames"

import {observer} from "mobx-react"

import XsSnackbar from "./global/ui/xsSnackbar/xsSnackbar"
// import XsButton from "./global/ui/xsButton/xsButton"
import XsHeader from "./global/ui/xsHeader/xsHeader"
import XsFooter from "./global/ui/xsFooter/xsFooter"
import XsLoading from "./global/ui/xsLoading/xsLoading"

import LoginContainer from "./modules/login/loginContainer"
import Register from "./modules/login/register"
import RequestForm from "./modules/RequestForm/RequestForm"
import RegisterContainer from "./modules/login/registerContainer"
import ResetPasswordContainer from "./modules/login/resetPasswordContainer"
import XsInfoDialog from "./global/ui/xsDialog/xsInfoDialog"
import XsErrorDialog from "./global/ui/xsDialog/xsErrorDialog"
import XsConfirmationDialog from "./global/ui/xsDialog/xsConfirmationDialog"

import Requests from "./modules/requests/requests"
// import Profil from "./modules/profil/profil"

import InfoStore from "./global/store/InfoStore"
import ErrorStore from "./global/store/ErrorStore"
import RouterStore from "./global/store/RouterStore"
import GlobalStore from "./global/store/GlobalStore"
import RegistersCacheStore from "./global/store/RegistersCacheStore"

import {getUser, logout, echo} from "./global/helpers/actions"

import "./global/styles/global.less"
import CallsList from "./modules/calls/callsList"
import CallDetail from "./modules/calls/callDetail"
import MainContainer from "./modules/main/mainContainer"
import XsPublicHeader from "./global/ui/xsHeader/xsPublicHeader"
import {injectIntl} from "react-intl"
import ConfirmRegistrationDialog from "./modules/login/confirmRegistrationDialog"
import WaitingList from "./modules/waiting/waitingList"
import MaintenanceContainer from "./modules/maintenance/MaintenanceContainer"

function App() {
	const user = getUser()
	const id = new URLSearchParams(RouterStore.location.search).get("id")

	useEffect(() => {
		GlobalStore.loadCodelist(RouterStore.location.pathname)
	}, [RouterStore.location.pathname])

	useEffect(() => {
		if (
			isEmpty(user) &&
			RouterStore.location.pathname != "/" &&
			RouterStore.location.pathname != "/login" &&
			RouterStore.location.pathname != "/register" &&
			RouterStore.location.pathname != "/maintenance" &&
			RouterStore.location.pathname != "/waiting" &&
			RouterStore.location.pathname != "/registerFinish" &&
			RouterStore.location.pathname != "/passwordResetFinish"
		) {
			RouterStore.push("/login")
		}
	}, [RouterStore.location.pathname])

	return (
		<div
			id="app"
			className={classnames({
				"main-bg": RouterStore.location.pathname == "/requests"
			})}
		>
			{isSafe(user) ? (
				<Switch>
					<Route
						exact
						path="/"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<Requests {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/login"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<LoginContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/register"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<Register {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/calls"
						render={(props) => (
							<React.Fragment>
								<XsHeader />
								<main className="main_container">
									<CallsList {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/call"
						render={(props) => (
							<React.Fragment>
								<XsHeader />
								<main className="main_container">
									<CallDetail id={id} {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/registerFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<RegisterContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/passwordResetFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<ResetPasswordContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/request"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<RequestForm id={id} {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/requests"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<XsHeader />
								<main className="main_container">
									<Requests {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/maintenance"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<main className="main_container">
									<MaintenanceContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
				</Switch>
			) : (
				<Switch>
					<Route
						exact
						path="/"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<main className="main_container">
									<MainContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/login"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<LoginContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/maintenance"
						render={(props) => (
							<React.Fragment>
								<XsPublicHeader />
								<main className="main_container">
									<MaintenanceContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/register"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<Register {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/waiting"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<XsPublicHeader />
									<WaitingList {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/registerFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<RegisterContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
					<Route
						exact
						path="/passwordResetFinish"
						render={(props) => (
							<React.Fragment>
								<main className="main_container">
									<ResetPasswordContainer {...props} />
								</main>
								<XsFooter />
							</React.Fragment>
						)}
					/>
				</Switch>
			)}
			<XsSnackbar />
			{(GlobalStore.isLoading || RegistersCacheStore.registersLoading) && <XsLoading overlay />}
			{ErrorStore.isOpen && <XsErrorDialog />}
			{InfoStore.isOpen && <XsInfoDialog />}
			{GlobalStore.confirmRegistrationDialogOpened && <ConfirmRegistrationDialog />}
			<XsConfirmationDialog
				name="xsWarningTokenExpired"
				text={`Platnosť vášho prihlásenia vyprší o ${GlobalStore.countdownExpireToken} sekúnd!`}
				confirmBtn={{
					icon: <i className="fal fa-check" />,
					text: "Common.btn.renew"
				}}
				cancelBtn={{
					icon: <i className="fal fa-times" />,
					text: "Common.btn.logout"
				}}
				onConfirmation={() => {
					echo()
				}}
				onCancel={() => {
					logout()
				}}
			/>
		</div>
	)
}

export default injectIntl(observer(App))

